import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { MatButton, MatDialog, MatDialogRef, MatTableDataSource } from '@angular/material';
import { ToastrService } from 'ngx-toastr';
import { CotizacionesCondicionesService } from 'src/app/services/cotizacionesCondiciones/cotizacionesCondiciones.service';
import { Dialogs } from 'src/app/ui/dialogs/dialogs';
import { Wait } from 'src/app/ui/wait/Wait';
import { CondicionesTiposDescripcionesCreateComponent } from '../create/create.component';

@Component({
  selector: 'app-condiciones-tipos-descripciones-index',
  templateUrl: './index.component.html',
  styleUrls: ['./index.component.css']
})
export class CondicionesTiposDescripcionesIndexComponent implements OnInit {

  @ViewChild('btnCerrar', {static:false})       btnCerrar       : MatButton;
  @ViewChild('tableContainer', {static: false}) tableContainer  : ElementRef;

  private boolGuardar : boolean = false;
  private objDialogs  : Dialogs = new Dialogs();
  private lstRows     : Array<any> = [];

  public objData  : any = null;

  // COLUMNS
  columns: string[] = ['index', 'opciones', 'descripcion', 'createdAspNetUser', 'createdFecha', 'updatedAspNetUser', 'updatedFecha'];

  // SEARCH FILTERS
  searchFilters : Array<any> = [{field : 'Nombre'}, {field : 'ApellidoPaterno'}, {field : 'ApellidoMaterno'}];
  
  dataSource : MatTableDataSource<any>;

  constructor(private objDialogRef : MatDialogRef<CondicionesTiposDescripcionesIndexComponent>, 
              private dialog: MatDialog,
              private objCotizacionesCondicionesService : CotizacionesCondicionesService,
              private toastr: ToastrService) { }

  ngOnInit() {
    this.dataSource = new MatTableDataSource<any>();
  }

  ngAfterViewInit() {
    this.build();
  }

  // EVENTOS
  close()
  {
    if(!this.boolGuardar)
    {
      this.objDialogRef.close();
    }
  }

  btnNuevo_clickEvent() {
    
    const dialogRef = this.dialog.open(CondicionesTiposDescripcionesCreateComponent, {
      width     : '99%',
      height    : '99%',
      maxWidth  : '400px',
      maxHeight : '300px'
    });

    dialogRef.componentInstance.objData = this.objData;

    dialogRef.componentInstance.onChange.subscribe(() => {
      this.build();
    });
    
  }

  btnEdit_clickEvent(element : any) {
    
    const dialogRef = this.dialog.open(CondicionesTiposDescripcionesCreateComponent, {
      width     : '99%',
      height    : '99%',
      maxWidth  : '400px',
      maxHeight : '300px'
    });

    dialogRef.componentInstance.objData = element;
    dialogRef.componentInstance.isEdit  = true;

    dialogRef.componentInstance.onChange.subscribe(() => {
      this.build();
    });

  }

  btnDelete_clickEvent(element : any) {
    
    this.objDialogs.Confirm("Eliminar", "¿Eliminar descripción "+ element.descripcion +"?", "Eliminar", "Cancelar", ()=> {
      this.delete(element.idCotizacionCondicion);
    });

  }

  // METODOS
  private loading(value : boolean) {
    if(value) {

      this.btnCerrar.disabled         = true;
      this.boolGuardar                = true;
      this.objDialogRef.disableClose  = true;

    } else{

      this.btnCerrar.disabled         = false;
      this.boolGuardar                = false;
      this.objDialogRef.disableClose  = false;

    }
  }

  private build() : void {

    let varArgs : any = {
      search                    : "",
      searchFilters             : this.searchFilters,
      filters                   : [],
      dateFrom                  : "",
      dateTo                    : "",
      dateOptions               : [{field : "CreatedFecha"}],
      columns                   : [],
      persistenceColumns        : [],
      length                    : 500,
      page                      : 1,
      idCotizacionCondicionTipo : this.objData.idCotizacionCondicionTipo
    };

    Wait.show(this.tableContainer, "Cargando datos...");

    this.objCotizacionesCondicionesService.dataSource(varArgs)
    .subscribe( objResponse => {

      if(objResponse.session) {

        if(objResponse.action) {

          this.lstRows = objResponse.result.rows;

          this.dataSource = new MatTableDataSource(this.lstRows);

        } else {
          this.toastr.error(objResponse.message, objResponse.title, { timeOut: 2000 });
        }

      } else {
        this.toastr.error(objResponse.message, objResponse.title, { timeOut: 2000 });
      }
      
      Wait.hide(this.tableContainer);
      
    }, error => {
      Wait.hide(this.tableContainer);

      if( error.status == 401) {
        this.toastr.error("La sesión ha finalizado.", "Error de sesión", { timeOut: 2000 });
      } else {
        this.toastr.error("Póngase en contacto con el administrador.", "Error de conexión al servidor");
      }

    });
    
  }

  private delete(idCotizacionCondicion : any) : void {
    
    Wait.show(this.tableContainer, "Eliminando...");
    this.loading(true);

    let objCotizacionCondicion : any =
    {
      idCotizacionCondicion : idCotizacionCondicion
    };

    this.objCotizacionesCondicionesService.delete(objCotizacionCondicion)
    .subscribe( objResponse => {
    
      if(objResponse.session) {

        if(objResponse.action) {
          
          this.build();
          this.objDialogs.Success(objResponse.title, objResponse.message);
          
        } else {
          this.toastr.error(objResponse.message, objResponse.title, { timeOut: 2000 });
        }
      } else {
        this.toastr.error(objResponse.message, objResponse.title, { timeOut: 2000 });
      }

      Wait.hide(this.tableContainer);
      this.loading(false);

    }, error => {

      Wait.hide(this.tableContainer);
      this.loading(false);

      if( error.status == 401) {
        this.toastr.error("La sesión ha finalizado.", "Error de sesión", { timeOut: 2000 });
      } else {
        this.toastr.error("Póngase en contacto con el administrador.", "Error de conexión al servidor");
      }

    });
  }
}
